module.exports = __webpack_public_path__ + "static/media/census module.89acf048.svg";